module.exports = __webpack_public_path__ + "static/media/slider-tecnohaft.f0c9bb0f.png";